export default __webpack_public_path__ + "static/media/icon-verified-blue.c9b19813.svg";